<template>
  <transition name="fade">
    <form @submit="checkForm">
  <div class="p-20">
    <div class="row">
      <div class="col-md-6">
        <h2>Bitte genaue Adresse wählen</h2>
        <b-form-select class="form-control" :options="state.locationOptions" v-model="selected"></b-form-select>
      </div>
      <div class="col-md-6 text-center pt50">
          <button class="btn mt-10" type="button" v-on:click="back"><i class="fa fa-chevron-left"></i> Zurück</button> <button class="btn btn-default" style="margin-top:7px;margin-left:5px"><i class="fa fa-chevron-right"></i> Adresse übernehmen</button><br>

      </div>
    </div>
  </div>
    </form>
  </transition>
</template>

<script>

import axios from 'axios';
import { mapMutations } from 'vuex'
export default {

  name: 'LocationForm',
  components: {},
  methods: {
    ...mapMutations([
       'setLocations',"setResponseError","setPanelComponent","hidePanel","showLoading","hideLoading"
    ]),
    checkForm: function(e){
        e.preventDefault();
        if(this.$data.selected == null){
          return false;
        }
        this.checkLocation();
    },
  back: function(){
    this.setPanelComponent('LocationForm');
  },
    checkLocation: function(){
      var $this = this;
      this.showLoading();
      axios.post(inetApiLink,this.selected).then(function(response){
        $this.hideLoading();
        switch(response.data.status){
          case 'multiple':

            $this.setLocations(response.data.locations);

            $this.setPanelComponent('MultipleForm');
            break;
          case 'error':
            $this.setResponseError(response.data.message);
            break;
          case 'success':
            document.location.reload();
            break;
        }

      })
    }
  },
  data() {
    return{
      selected: null,
      defaultColor: "#ffb302",
      state: this.$store.state
  }},
  props: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .mt-10{
    margin-top: 10px;
  }
  .pt50{
    padding-top: 37px;
  }

  .btn-default{
    background: #fac800;
    min-width: 300px;
    font-size: 1em;
  }
  .btn-abort{
    min-width: 300px;
    font-size: 1em;
  }
  select{
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 1.8rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
  }

</style>
